<template>
        <div class="card back" :class="'bg_' + prize.code">
            <div class="title">
                <div class="title-left"></div>
                <div class="title-content" :class="$i18n.locale">{{ $t("task.won") }}</div>
                <div class="title-right"></div>
            </div>
            <div class="prize">
                <span class="text">1 {{$t("task.card")}}</span>
                <span class="add"> + </span>
                <span class="amount">₹ {{prize.amount}}</span>
            </div>
            <div class="msg" :class="$i18n.locale">{{ $t("task.msg") }}</div>
            <div class="button" @click="confirm">
                {{ btnMsg ? btnMsg: $t("task.ok") }}
            </div>
        </div>
</template>

<script>
export default {
  name: "card",
  props: {
    prize: {
      type: Object,
      required: true
    },
    btnMsg: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
    };
  },
  methods: {
      confirm(){
          this.$emit('confirm')
      }
  },
  mounted() {
    
  }
};
</script>

<style lang="scss" rel="stylesheet/sass" scoped="scoped">
@import "@/assets/scss/reset.scss";
@import "@/assets/scss/function.scss";
.card{
	display: block;
	position: absolute;
	width: rem(500px); 
    height: rem(754px); 
    backface-visibility: hidden;//关键代码
}
.back{
    &.bg_h{
        background-image: url("../../assets/images/popup/h_bg.webp");
        background-size: 100% 100%;
    }
    &.bg_o{
        background-image: url("../../assets/images/popup/o_bg.webp");
        background-size: 100% 100%;
    }
    &.bg_l{
        background-image: url("../../assets/images/popup/l_bg.webp");
        background-size: 100% 100%;
    }
    &.bg_i{
        background-image: url("../../assets/images/popup/i_bg.webp");
        background-size: 100% 100%;
    }
    .close {
        position: absolute;
        right: rem(0px);
        top: rem(0px);
        width: rem(42px);
        height: rem(43px);
        background-image: url("../../assets/images/popup/close.png");
        background-size: 100% 100%;
    }
    .title{
        width: rem(466px);
        margin: 0 auto;
        padding-top: rem(420px);
        display:flex;
        align-items: center;
        .title-left{
            width: rem(140px);
            height: rem(5px);
            background-image: url("../../assets/images/popup/won_line1.png");
            background-size: 100% 100%;
        }
        .title-content{
            width: rem(186px);
            font-size: rem(30px);
            color: #ffffff;
            font-weight: bold;
            text-align: center;
            &.ta{
                font-size: rem(22px);
            }    
        }
        .title-right{
            width: rem(140px);
            height: rem(5px);
            background-image: url("../../assets/images/popup/won_line2.png");
            background-size: 100% 100%;
        }
    }
    .prize{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        .text{
            font-size: rem(46px);
        }
        .amount{
            font-size: rem(54px);
        }
        .add{
            font-weight: bold;
            color: #F4FF00;
            margin: rem(0 20px);
        }
    }
    .msg{
        font-size: rem(26px);
        text-align: center;
        color: #fff;
        margin: rem(10px 50px);
        &.ta{
            font-size: rem(20px);
        }
    }
    .button{
        width: rem(344px);
        height: rem(107px);
        line-height:  rem(97px);
        color: #E80211;
        text-align: center;
        background-image: url("../../assets/images/popup/pop_btn.png");
        background-size: 100% 100%;
        font-weight: bold;
        margin: rem(15px) auto 0 auto;;
        font-size: rem(34px);
    }
}

</style>
